var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Filtro',{on:{"filtro":_vm.makeFiltro}}),_c('vs-card',[_c('List',{attrs:{"filtro":_vm.filtro,"realizaFiltro":_vm.realizaFiltro,"subjectPermission":_vm.subjectPermission},on:{"filtroOk":_vm.finalizaFiltro}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }